import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const token = localStorage.getItem('token');

  if (token !== null && token !== undefined) {
    return true;
  }

  localStorage.removeItem('token');
  localStorage.removeItem('user');
  router.navigate(['/login']).then();
  return false;
};
